import { Component, Input, OnInit } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { ICardGarbageModel } from '@types-custom/models/ui/card-garbage-model';
import { DrawerPanelService } from '@ui-core/services/drawer-panel/drawer-panel.service';

@Component({
  selector: 'citizen-panel-garbage',
  templateUrl: './panel-garbage.component.html',
  styleUrls: ['./panel-garbage.component.scss']
})
export class PanelGarbageComponent implements OnInit {
  @Input() cards: ICardGarbageModel[] = [];
  Icon = Icon;
  searchText = '';
  currentPage = 0;
  pageSize = 10;
  totalRecords = 0;
  filteredCards: ICardGarbageModel[] = [];
  displayedCards: ICardGarbageModel[] = [];

  constructor(private drawerPanelService: DrawerPanelService) { }

  ngOnInit(): void {
    this.filteredCards = [...this.cards];
    this.totalRecords = this.cards.length;
    this.updateDisplayedCards();
  }

  openModal(card: ICardGarbageModel): void {
    this.drawerPanelService.collapseDrawer(true);
    card?.cardMapLink?.markerDispatcher.next(
      card.cardMapLink.markerModel
    );
  }

  onSearch(): void {
    if (!this.searchText.trim()) {
      this.filteredCards = [...this.cards];
    } else {
      const search = this.searchText.toLowerCase();
      this.filteredCards = this.cards.filter(card => 
        card.location?.toLowerCase().includes(search) ||
        card.binId?.toLowerCase().includes(search) ||
        card.binCategory?.toLowerCase().includes(search) ||
        card.wardId?.toLowerCase().includes(search) ||
        card.licensePlate?.toLowerCase().includes(search)
      );
    }
    this.totalRecords = this.filteredCards.length;
    this.currentPage = 0;
    this.updateDisplayedCards();
  }

  updateDisplayedCards(): void {
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    this.displayedCards = this.filteredCards.slice(start, end);
  }

  nextPage(): void {
    const totalPages = Math.ceil(this.totalRecords / this.pageSize);
    if (this.currentPage < totalPages - 1) {
      this.currentPage++;
      this.updateDisplayedCards();
    }
  }

  previousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updateDisplayedCards();
    }
  }

  goToFirstPage(): void {
    this.currentPage = 0;
    this.updateDisplayedCards();
  }

  goToLastPage(): void {
    this.currentPage = Math.ceil(this.totalRecords / this.pageSize) - 1;
    this.updateDisplayedCards();
  }

  changePageSize(size: number): void {
    this.pageSize = size;
    this.currentPage = 0;
    this.updateDisplayedCards();
  }

  getStatusClass(card: ICardGarbageModel): string {
    const level = parseFloat(card.binFillingLevel || '0');
    if (level >= 0.8) return 'status-high';
    if (level >= 0.5) return 'status-medium';
    return 'status-low';
  }

  getStatusText(card: ICardGarbageModel): string {
    const level = parseFloat(card.binFillingLevel || '0');
    if (level >= 0.8) return 'Alta';
    return 'Baja';
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  formatTime(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
  }

  getFillingPercentage(card: ICardGarbageModel): number {
    return card.binFillingLevel ? Math.round(parseFloat(card.binFillingLevel)) : 0;
  }

}
